import { axiosInstance } from '../../api';
const BASE_PATH = '/pending_onboarding';

//get Pending Onboards
export let getPendingOnboards = async (pipeline_id, is_all) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_pending_onboards', {
            pipeline_id: pipeline_id,
            is_all: is_all
        });
        return value
    } catch (error) {
        return error
    }
}

//get Hiring Piepelines Of Onboards
export let getHiringPiepelinesOfOnboards = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_hiring_pipelines_of_onboards')
        return value;
    } catch (error) {
        return error
    }
}

export let pushedToOnboarding = async (onboarding_session_id, passed_reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/pushed_to_onboarding', {
            onboarding_session_id: onboarding_session_id,
            passed_reason: passed_reason
        });
        return value
    } catch (error) {
        return error
    }
}

export let rejectOnOnboarding = async (onboarding_session_id, failed_reason) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/reject_on_onboarding', {
            onboarding_session_id: onboarding_session_id,
            failed_reason: failed_reason
        });
        return value
    } catch (error) {
        return error
    }
}

export let pushToHris = async (onboarding_session_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/push_to_hris', {
            onboarding_session_id: onboarding_session_id,
        });
        return value
    } catch (error) {
        return error
    }
}

//get Hiring Piepelines Of Onboards
export let getExportDetails = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_onboarding_export_data')
        return value;
    } catch (error) {
        return error
    }
}